// Internal Solid context cho plugin. Public API exposed qua useAgentUi() hook.

import { createContext } from "solid-js";
import type { AgentUiContextValue } from "./types";

export const AgentUiContext = createContext<AgentUiContextValue>();
